<template>
  <span>
    <svg
      width="337"
      height="297"
      viewBox="0 0 337 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.91129 296.648C5.8041 296.651 4.71247 296.388 3.72878 295.879C2.7451 295.371 1.89833 294.633 1.26013 293.728C0.621938 292.823 0.211113 291.778 0.0624286 290.68C-0.0862555 289.583 0.0315787 288.465 0.405957 287.423L100.366 7.37011C101.122 5.21229 102.53 3.34333 104.396 2.02263C106.262 0.701939 108.493 -0.0049692 110.778 2.62947e-05H220.11C222.41 2.62947e-05 224.592 0.694381 226.397 1.97398C228.212 3.25357 229.65 5.01922 230.473 7.20148L336.065 287.304C336.468 288.35 336.608 289.479 336.471 290.591C336.334 291.704 335.926 292.765 335.282 293.682C334.65 294.602 333.802 295.353 332.814 295.87C331.825 296.387 330.725 296.654 329.61 296.648H242.611C240.666 296.655 238.769 296.052 237.186 294.922C235.608 293.775 234.429 292.162 233.815 290.31L219.981 249.392H112.99L99.5726 290.31C98.9843 292.175 97.7997 293.796 96.2009 294.922C94.6154 296.054 92.7142 296.657 90.7666 296.648H6.91129ZM168.424 96.6046C168.008 95.454 166.857 94.8787 165.707 94.9183C164.517 94.9183 163.396 95.5333 163.029 96.7236L149.533 138.008L135.997 179.253H196.32L168.424 96.6046Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>

<script setup lang="ts"></script>
<style scoped lang="postcss">
span {
  display: inline-block;
  transform-origin: bottom center;
  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
